"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OptionContent = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var iconWrapper_1 = require("../iconWrapper");
/** Incredibly simple utility component for use in options, used to optionally render JSX, a piece of text, or fallback to an ID - for use with components which render an array of the IArmstrongOption (or similar) type */
var OptionContent = function (_a) {
    var name = _a.name, content = _a.content, leftIcon = _a.leftIcon, rightIcon = _a.rightIcon, id = _a.id;
    var textContent = React.useMemo(function () {
        if (typeof content === 'string' || typeof content === 'number') {
            return content;
        }
        if (content) {
            return undefined;
        }
        if (name) {
            return name;
        }
        if (id) {
            return id;
        }
    }, [content, name, id]);
    return (React.createElement(iconWrapper_1.IconWrapper, { leftIcon: leftIcon, rightIcon: rightIcon }, textContent ? React.createElement("p", null, textContent) : content));
};
exports.OptionContent = OptionContent;
